import { Dispatch, SetStateAction } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  UserRoles,
  isAbleToSeeUIElement,
} from '../../../../../utils/roles/client-roles';
import { UserKeys } from '../../../../../api/users-api';
import { Messages } from '../../../../../utils/message-constants';
import SharedToolbar from '../../../../../shared/shared-toolbar-latest';
import CreateButton from '../../../../../shared/buttons/create-button';
import SharedIconButton from '../../../../../shared/buttons/shared-icon-button';
interface GmailFiltersToolbarProps {
  userRoles: string[];
  userEmail: string;
  selectedRows: string[];
  setOpenAddGmailFilter: Dispatch<SetStateAction<boolean>>;
  setOpenDeleteGmailFilters: Dispatch<SetStateAction<boolean>>;
}

export default function GmailFiltersToolbar({
  userRoles,
  userEmail,
  selectedRows,
  setOpenAddGmailFilter,
  setOpenDeleteGmailFilters,
}: GmailFiltersToolbarProps) {
  const queryClient = useQueryClient();

  return (
    <SharedToolbar
      noColumn
      noFilter
      primaryButtons={
        <CreateButton
          onClick={() => setOpenAddGmailFilter(true)}
          disabled={
            !isAbleToSeeUIElement(userRoles, UserRoles.AddGmailFilters.value)
          }
          label="Add Filter"
          tooltipLabel={
            !isAbleToSeeUIElement(userRoles, UserRoles.AddGmailFilters.value)
              ? Messages.Errors.Permission.Acting(
                  UserRoles.AddGmailFilters.name
                )
              : 'Add Filter'
          }
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="delete"
            onClick={() => setOpenDeleteGmailFilters(true)}
            disabled={
              selectedRows.length === 0 ||
              !isAbleToSeeUIElement(
                userRoles,
                UserRoles.DeleteGmailFilters.value
              )
            }
            tooltipLabel={
              !isAbleToSeeUIElement(
                userRoles,
                UserRoles.DeleteGmailFilters.value
              )
                ? Messages.Errors.Permission.Acting(
                    UserRoles.DeleteGmailFilters.name
                  )
                : 'Delete'
            }
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              void queryClient.invalidateQueries({
                queryKey: [UserKeys.GmailFilters, userEmail],
              });
              void queryClient.invalidateQueries({
                queryKey: [UserKeys.GmailLabels, userEmail],
              });
            }}
            tooltipLabel="Refresh"
          />
        </>
      }
    />
  );
}
